<template>
    <div class="process-search-new">
        <div>
            <m-table
                class="process-search-table"
                :class="searchClass"
                ref="RegistrationTable"
                :pageTotal="pageTotal"
                :tableData="listData"
                :config="tableConfig"
                @pageChange="pageChange"
                @sizeChange="sizeChange"
                @search="search"
                @getTableConfigList="getTableConfigList"
                @btn-event="goDetail"
                @handleSortChange="handleSortChange"
                @visibleChange="visibleChange"
                @cascadeChange="cascadeChange"
                @expandRowKeysChange="expandRowKeysChange"
                @changeSecondQueryCondition="changeSecondQueryCondition"
            >
                <div slot="search-checkBox" class="search-checkBox">
                   <div>
                        展示物流最终节点
                        <el-checkbox
                            true-label="1"
                            false-label="0"
                            v-model="isReadTheLogistics"
                        ></el-checkbox>
                        展示最终节点
                        <el-checkbox
                            true-label="1"
                            false-label="0"
                            v-model="isReadTheEnd"
                        ></el-checkbox>
                        是否查询ES
                        <el-checkbox
                            true-label="2"
                            false-label="1"
                            v-model="selectFlag"
                        ></el-checkbox>
                    </div>
                    <div class="search-hint">
                        <div class="hint_bg">新功能</div>
                        <!-- <img src="../../../../../assets/hint_icon.png" alt="" > -->
                        <div class="hint_text">
                            条码流向：支持以上所有条件查询！
                        </div>
                    </div>
                </div>
                <template v-slot:table-expand="{ props }">
                    <div class="table-expand">
                        <!-- slot-scope="props" -->
                        <div class="table-expand-container">
                            <div class="column">
                                <div class="title">物流信息</div>
                                <div class="row">
                                    <span class="label">扫码来源：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.scanSystem
                                        )
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">扫码仓库：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.whName,
                                            props.row.whCode
                                        )
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">任务单号：</span>
                                    <span class="value">{{
                                        rowContentFactory(props.row.taskNo)
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">服务平台：</span>
                                    <span class="value">{{
                                        rowContentFactory(props.row.siteName)
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">业务模式：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.businessMode
                                        )
                                    }}</span>
                                </div>
                            </div>
                            <div class="column">
                                <div class="title">&nbsp;</div>
                                <div class="row">
                                    <span class="label">发车单号：</span>
                                    <span class="value">{{
                                        rowContentFactory(props.row.dispatchNo)
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">承运商：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.carrierName,
                                            props.row.carrierCode
                                        )
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">司机：</span>
                                    <span class="value">{{
                                        rowContentFactory(props.row.driver)
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">配送方式：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.deliveryTypeName
                                        )
                                    }}</span>
                                </div>
                                <!-- <div class="row">
                                    <span class="label">发货地址：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.senderDetailAddr
                                        )
                                    }}</span>
                                </div>
                                <div class="row">
                                    <span class="label">收货地址：</span>
                                    <span class="value">{{
                                        rowContentFactory(
                                            props.row.receiverDetailAddr
                                        )
                                    }}</span>
                                </div> -->
                                <div class="row">
                                    <span class="label">网点：</span>
                                    <span class="value">{{
                                        rowContentFactory(props.row.netWorkName)
                                    }}</span>
                                </div>
                            </div>
                            <div class="column">
                                <div class="title">&nbsp;</div>
                                <div class="row">
                                    <span class="label">外部平台单号：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.externalOrderNo
                                            )
                                        }}</span
                                    >
                                </div>
                                <div class="row">
                                    <span class="label">外部货主：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.upCustomerName
                                            )
                                        }}</span
                                    >
                                </div>
                                <div class="row warp-row">
                                    <span class="label">运单号：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.expressCode
                                            )
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div class="column">
                                <div class="title">订单信息</div>
                                <div class="row">
                                    <span class="label">发货租户：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.shipTenantName,
                                                props.row.shipTenantCode
                                            )
                                        }}</span
                                    >
                                </div>
                                <div class="row">
                                    <span class="label">收货租户：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.recTenantName,
                                                props.row.recTenantCode
                                            )
                                        }}</span
                                    >
                                </div>
                                <div class="row">
                                    <span class="label">发货仓库：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.shipOrgWhName,
                                                props.row.shipOrgWhCode
                                            )
                                        }}</span
                                    >
                                </div>
                                <div class="row">
                                    <span class="label">收货仓库：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.recOrgWhName,
                                                props.row.recOrgWhCode
                                            )
                                        }}</span
                                    >
                                </div>
                                 <div class="row">
                                    <span class="label">源平台：</span>
                                    <span class="value">
                                        {{
                                            rowContentFactory(
                                                props.row.sourceChannelName,
                                            )
                                        }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:column-barcodeNo="{ props }">
                    <div class="barcode-row">
                        <div class="barcode-row-icon">
                            <template v-if="props.row.chidrenList">
                                <i
                                    v-if="props.row.treeListStatus"
                                    class="el-icon-arrow-down"
                                    @click="changeTreeList(props.row, false)"
                                ></i>
                                <i
                                    v-else
                                    class="el-icon-arrow-up"
                                    @click="changeTreeList(props.row, true)"
                                ></i>
                            </template>
                        </div>
                        <div>
                            {{ props.row.barcodeNo }}
                        </div>
                    </div>
                </template>
                <template v-slot:page-module-btn>
                    <div class="btnList">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="openExportModal"
                            >批量查询导出</el-button
                        >

                        <reportExport #default="{ submit }" reportCode="">
                            <el-button
                                size="mini"
                                type="primary"
                                @click="searchExport(submit)"
                                >导出</el-button
                            >
                        </reportExport>
                    </div>
                </template>
            </m-table>
        </div>
        <export-modal
            ref="exportModal"
            :listData="listData"
            :columnsParams="columnsParams"
            :isReadTheEnd="isReadTheEnd"
            :selectFlag="selectFlag"
            :isReadTheLogistics="isReadTheLogistics"
        />
    </div>
</template>
<script>
import exportModal from './exportModal';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { searchLcbsProcessData, exportCheck } from '../../../../../api/lcbsManagement.js';
import { tableConfig } from './tableConfig.js';
import { searchByDictCodes, sceneDomainList } from '../../../../../api/systemManagementApi.js';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { fetchEyeInfo } from '../../../../../api/productProcess.js';
const EXPORT_API = '/api-sn/lbcs/domesticBarcodeFullProcess/export'; // 通用导出接口路径
const billDateNotNull = ['itemCode', 'billTypeClassList', 'inOutType', 'scanSystemList', 'recSourceSysList', 'recTenantCode', 'shipTenantCode', 'recOrgTypeList', 'shipOrgTypeList']; // 使用这些参数需要单据时间必填

export default {
    name: 'processSearchNew',
    components: { mTable, exportModal, reportExport },
    data() {
        return {
            tableConfig,
            // searchLoading: false,
            listData: [],
            billTypeList: [],
            treeList: [],
            pageTotal: 0,
            isReadTheEnd: '0',
            isReadTheLogistics: '0',
            selectFlag: '2',
            searchData: {},
            isCloseFlag: 'openStyle',
            dictObj: { SN_LBCS_SHIP_ORG_TYPE: {} },
            listExportParams: {},
            exportColumns: tableConfig.table.columns,
            searchClass: ''
        };
    },
    watch: {
        'billTypeList': {
            handler(val) {
                this.tableConfig.searchList.searchTxt.some(item => {
                    if (item.value === 'billTypeClassList') {
                        item.options = val.map(row => {
                            return {
                                label: row.billTypeName,
                                value: row.billTypeName
                            };
                        });
                    }
                });
            },
            deep: true
        },
        'treeList': {
            handler(val) {
                const newList = [];
                val.forEach((item) => {
                    newList.push(item);
                    if (item.chidrenList && item.treeListStatus) {
                        newList.push(...item.chidrenList);
                    }
                });
                this.listData = newList;
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        // listData() {
        //     const newList = [];
        //     this.treeList.forEach((item) => {
        //         newList.push(item);
        //         if (item.chidrenList && item.treeListStatus) {
        //             newList.push(...item.chidrenList);
        //         }
        //     });
        //     return newList;
        // },
        // 导出使用的列配置
        columnsParams() {
            const list = [];
            this.exportColumns.forEach((item) => {
                if (!item.hiddenColumn) {
                    list.push(item.prop);
                }
            });
            if (list.length === this.exportColumns.length) return '';
            return list;
        }
    },
    methods: {
        // 订单系统选中并且只选一个则请求领域表数据作为单据类型下拉
        cascadeChange(val, data) {
            if (data.value !== 'recSourceSysList') return;
            this.$refs.RegistrationTable.setSeachFormValue('billTypeClassList', []);
            if (val.length === 1) {
                const params = {
                    pageNo: 1,
                    pageSize: 100,
                    sourceSys: val[0]
                };
                sceneDomainList(params).then(res => {
                    if (res.code === '0' && res.data) {
                        this.billTypeList = res.data.list;
                    }
                });
            } else {
                this.billTypeList = [];
            }
        },
        visibleChange (val, data) {
            if (data.value !== 'billTypeClassList') return;
            if (val && this.billTypeList.length === 0) {
                this.$message.warning('根据单据类型查询，请先确定1个订单系统！');
            }
        },
        rowContentFactory(value, code) {
            let content = '--';
            if (value) {
                content = value + '';
                if (code) content = value + '(' + code + ')';
            }
            return content;
        },
        onSearchDataChange(data) {
            this.searchData = data;
        },
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        goDetail(selection, index, event) {
            if (event === 'detail') {
                this.$emit('goDetail', selection);
            }
        },
        // 原逻辑
        search(data) {
            // data.barcodeNo = '3112201133697180510004';
            this.searchData = {
                ...data
            };
            const flag = this.checksSearchData();
            this.tableConfig.page.pageNo = 1;
            flag && this.getData();
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.getData();
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.getData();
        },
        checksSearchData() {
            let isLabel = '';
            let billDateIsNull = false;
            Object.keys(this.searchData).forEach(key => {
                if (!billDateIsNull) {
                    const barcodeOrSource = this.searchData.barcodeNoSplit || this.searchData.sourceBillNoSplit;
                    const keyType = Array.isArray(this.searchData[key]) ? this.searchData[key].length : this.searchData[key];
                    const isBill = (this.searchData.billDate && this.searchData.billDate.length) || this.searchData.billBeginDate;
                    billDateIsNull = !barcodeOrSource && billDateNotNull.includes(key) && keyType && !isBill;
                }
                if (!this.searchData[key] || this.searchData[key].length === 0) {
                    delete this.searchData[key];
                }
                const index = key.indexOf('Date');
                if (index !== -1) {
                    if (Array.isArray(this.searchData[key])) {
                       const start = key.substring(0, index);
                        this.searchData[start + 'BeginDate'] = this.searchData[key][0];
                        this.searchData[start + 'EndDate'] = this.searchData[key][1];
                        const sevenDaysLater = dayjs(this.searchData[key][0]).add(31, 'day').format('YYYY-MM-DD HH:mm:ss');
                        if (this.searchData[key][1] > sevenDaysLater) {
                            isLabel = this.tableConfig.searchList.searchTxt.filter(item => item.value === key)[0].name;
                        }
                        delete this.searchData[key];
                    }
                }
            });
            if (isLabel) {
                this.$message.warning(`${isLabel}查询范围不能大于31天`);
                return false;
            }
            if (this.selectFlag === '1') {
                if (!this.searchData.barcodeNoSplit && !this.searchData.sourceBillNoSplit) {
                    this.$message.warning('条码字符串、单据编码不能同时为空');
                    return false;
                }
            } else {
                if (billDateIsNull) {
                    this.$message.warning('单据时间不能为空');
                    return false;
                }
            }
            if (!Object.values(this.searchData).length) {
                this.$message.warning('请先输入至少一个查询条件！');
                return false;
            }
            return true;
        },
        getData() {
            const params = Object.assign({}, this.searchData);
            params.isReadTheEnd = this.isReadTheEnd;
            params.selectFlag = this.selectFlag;
            params.newViewFlag = 'Y';
            params.isReadTheLogistics = this.isReadTheLogistics;
            params.pageSize = this.tableConfig.page.pageSize;
            params.pageNo = this.tableConfig.page.pageNo;
            this.listExportParams = params;
            this.treeList = [];
            searchLcbsProcessData(params).then((res) => {
                if (res.code === '0' && res.data) {
                    this.setData(res.data);
                }
            });
        },
        // 这里处理树结构
        setData(data) {
            const list = data.list || [];
            this.pageTotal = data.totalCount;
            const treeList = [];
            list.sort((a, b) => {
                return new Date(a.opDate) - new Date(b.opDate);
            });
            list.forEach((item) => {
                item.swapId = item.swapId + '';
                item.isExpand =
                    !item.isExpanded || `${item.isExpanded}` !== '1';
                item.recOrgType =
                    this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.recOrgType];
                item.shipOrgType =
                    this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.shipOrgType];
                const flag = treeList.every((treeItem) => {
                    if (treeItem.barcodeNo === item.barcodeNo) {
                        const oldList = treeItem.chidrenList || [];
                        treeItem.chidrenList = [...oldList, item];
                        treeItem.treeListStatus = true;
                        return false;
                    } else {
                        return true;
                    }
                });
                if (flag) treeList.push(item);
            });
            this.treeList = treeList;
        },
        // handleDicts() {
        //     const params = {
        //         dictCodes: 'SN_LBCS_SHIP_ORG_TYPE'
        //     };
        //     searchByDictCodes(params).then((res) => {
        //         if (res && res.data) {
        //             Object.keys(res.data).forEach((key) => {
        //                 const obj = {};
        //                 res.data[key].forEach((item) => {
        //                     obj[item.code] = item.name;
        //                 });
        //                 this.dictObj[key] = obj;
        //             });
        //         }
        //     });
        // },
        openExportModal() {
            this.$refs.exportModal.open();
        },
        async searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.listExportParams
            };
            if (this.columnsParams) params.columns = this.columnsParams;
            const flag = this.checksSearchData(this.listExportParams);
            if (!flag) return;
            if (!this.listData.length) {
                this.$message.warning(
                    this.$translate('lang.EXC202101260002', {
                        defaultText: '暂无导出数据,请重新设置查询条件'
                    })
                );
                return;
            }
            const res = await exportCheck(params);
            if (res.code === '0') {
                submit(params);
            }
        },
        changeTreeList(row, isOpen) {
            this.treeList.some((item) => {
                if (item.swapId === row.swapId) {
                    item.treeListStatus = isOpen;
                    return true;
                }
            });
        },
        // 排序这里有歧义
        handleSortChange(data) {
            // console.log(data);
        },
        async dictData() {
            const params = {
                dictCodes: 'ORDER_SYSTEM,SCAN_SYSTEM,SN_LBCS_SHIP_ORG_TYPE'
            };
            const option = await searchByDictCodes(params);
            this.tableConfig.searchList.searchTxt.forEach((item) => {
                if (item.dicOptionsKey && option.data[item.dicOptionsKey]) {
                    item.options = this.dicEnable(option.data, item.dicOptionsKey);
                }
            });
        },
        // 对数据字典进行格式处理
        dicEnable(options, key) {
            if (options[key]) {
                let data = options[key];
                if (key !== 'SN_LBCS_SHIP_ORG_TYPE') {
                    data = data.filter(item => {
                        item.name = `${item.code}-${item.name}`;
                        return item.tenantCode === this.currentTenant.tenantCode;
                    });
                }
                const list = data.map(item => {
                    if (!this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.code] && key === 'SN_LBCS_SHIP_ORG_TYPE') {
                        this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.code] = item.name;
                    }
                    return {
                        label: item.name,
                        value: item.code
                    };
                });
                return list;
            }
        },
        expandRowKeysChange(row, sourceBillNo) {
            const flag = this.treeList.some(item => item.sourceBillNo === sourceBillNo && item.sourceChannelName);
            const params = {
                sourceBillNo: sourceBillNo,
                isNeedReceiverAddress: false,
                isNeedReceiverPerson: false,
                isNeedSourceChannel: true
            };
            if (flag || !(sourceBillNo.startsWith('DOX') || sourceBillNo.startsWith('IOX'))) { return; }
            fetchEyeInfo(params).then(res => {
                if (res.code === '0') {
                    this.treeList = this.treeList.map(cue => {
                        if (cue.sourceBillNo === sourceBillNo) {
                            cue.sourceChannelName = res.data.sourceChannelName;
                        }
                        if (cue.chidrenList) {
                            cue.chidrenList = cue.chidrenList.map(item => {
                                if (item.sourceBillNo === sourceBillNo) {
                                    item.sourceChannelName = res.data.sourceChannelName;
                                }
                                return {
                                    ...item
                                };
                            });
                        }
                        return {
                            ...cue
                        };
                    });
                }
            });
        },
        changeSecondQueryCondition(flag) {
            flag ? this.searchClass = '' : this.searchClass = 'table_height';
        }
    },
    mounted() {
        // this.handleDicts();
        this.dictData();
    }
};
</script>
<style lang="less"  scoped>
.process-search-table {
    .table-expand-container {
        display: flex;
        font-size: 12px;
        .column {
            margin-right: 30px;
        }
        .row {
            display: flex;
            align-items: baseline;
            min-width: 200px;
            margin-top: 10px;
            color: #888;
        }
        .label {
            flex-shrink: 0;
        }
        .value {
            color: #000;
            word-wrap: break-word;
            word-break: break-all;
        }
        .title {
            font-size: 14px;
            font-weight: 600;
            color: #000;
        }
        .warp-row {
            max-width: 300px;
            // overflow: w;
        }
        .same-row {
            margin-left: 10px;
        }
    }
    /deep/ .el-table {
        height: calc(100vh - 395px) !important;
        .el-table__fixed {
            height: auto !important;
            bottom: 10px !important;
        }
    }
}
.table_height{
    /deep/ .el-table {
        height: calc(100vh - 273px) !important;
    }
}
.table-module-btn {
    padding-left: 10px;
    display: flex;
}
.search-checkBox {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333333;
}
.search-hint{
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #FFF;
    background: url(../../../../../assets/hint_icon.png) no-repeat;
    .hint_bg{
        width: 56px;
        height: 18px;
        box-sizing: border-box;
        font-size: 12px;
        text-align: right;
        transform: scale(0.8);
        line-height: 18px;
        white-space: nowrap;
    }
    .hint_text{
        font-size: 12px;
        margin-left: 10px;
        color: #FF3C3C;
    }
}
.barcode-row {
    display: flex;
    .barcode-row-icon {
        flex-shrink: 0;
        width: 20px;
        margin-right: 10px;
    }
}
</style>
